<template>
    <div>
        <facit-header></facit-header>
        <div class="profile-div col-12">
            <h5 class="mt-3 mb-3"> <a @click="users()" class="Userlink">
                    User Management</a> / Device </h5>
            <br><br>
            <b-table striped hover show-empty empty-text="There is no user history to show" :fields="tableFields"
                :items="history" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                <template slot="status" slot-scope="data">
                    <label class="switch">
                        <input type="checkbox" v-model="data.value" @change="StatusUpdate(data.item.id, data.value)">
                        <span class="slider round"></span>
                    </label>
                </template>

                <template slot="link" slot-scope="data">
                    <div>
                        <i @click="getDetail(data.item.id)" title="Edit">
                            <v-icon name="edit" base-class="icon-width" @click="getDetail(data.item.id)">
                            </v-icon>
                        </i>
                    </div>
                </template>

            </b-table>
            <br>
            <b-pagination align="right" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />

            <!--Edit Model-->

            <b-modal v-model="userSettingsModal" hide-footer title="Edit">
                <b-form @submit.prevent="updateProfile('formRegistration')" class="ml-4 mr-4 mb-4"
                    data-vv-scope="formRegistration">

                    <b-form-group id="nameGroup">
                        <b-row class="my-1">
                            <b-col sm="4">
                                <label for="input-small">Product Key</label>
                            </b-col>
                            <b-col sm="8">
                                <b-form-input id="limit" name="limit" type="text" :disabled="true" v-model="productKey"
                                    v-validate="'required'" :class="{
                                        'input': true,
                                        'is-danger': errors.has('formRegistration.limit')
                                    }" required placeholder="Product Key">
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                    <b-form-group id="nameGroup">
                        <b-row class="my-1">
                            <b-col sm="4">
                                <label for="input-small">License Key</label>
                            </b-col>
                            <b-col sm="8">
                                <b-form-input id="credit" name="credit" type="text" v-model="licenceKey"
                                    placeholder="License Key">
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                    <b-button type="submit" class="w-100" variant="warning">Save</b-button>
                </b-form>
            </b-modal>

        </div>
    </div>
</template>
  
<script>
import API from '@/api';
import FacitHeader from '@/components/header';

export default {
    name: 'userManagement',
    components: { FacitHeader },
    data() {
        return {
            licenceKey: '',
			credits:0,
            productKey: null,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            uuid: null,
            history: null,
            userAccount: null,
            userSettingsModal: false,
            tableFields: [
                {
                    key: 'hostName',
                    label: 'Host Name',
                    sortable: true,
                },
                {
                    key: 'date',
                    label: 'Date',
                    sortable: true,
                    formatter: (value) => {
                        const fullDate = new Date(value);
                        let day = fullDate.getDate();
                        let month = fullDate.getMonth() + 1;
                        const year = fullDate.getFullYear();
                        const hour = fullDate.getHours();
                        const min = fullDate.getMinutes();
                        const sec = fullDate.getSeconds();
                        if (day < 10) { day = `0${day}`; }
                        if (month < 10) { month = `0${month}`; }
                        return `${day}-${month}-${year}  ${hour}:${min}:${sec}`;
                    },
                },
                {
                    key: 'productKey',
                    label: 'Product Key',
                    sortable: false,
                },
                {
                    key: 'licenceKey',
                    label: 'Licence Key',
                    sortable: true,
                },
                {
                    key: 'credits',
                    label: 'Credits',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                },
                {
                    key: 'link',
                    label: 'Action',
                    sortable: false,
                },
            ],
        };
    },
    async created() {
        const userId = this.$route.query.id;
        this.getHistory(userId);
    },
    methods: {
        async onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            // this.currentPage = 1
        },
        async getHistory(userId) {
            // this.history = await API.get(`Accounts/${userId}/?filter={"include": ["devices", "HistoryExports"]}`);
            // this.userAccount = await API.get(`Accounts/${userId}`);
            this.uuid = userId
            this.history = await API.get(`/ProductKeys?filter={"where":{"userId":"${userId}"}}`)

            this.history.filter((data, index) => {
                // try {
                if (data.licenceKey == null) {
                    data.licenceKey = '';
                } else {
                    data.licenceKey = data.licenceKey.substring(0, 9);
                }
                // } catch (e) { }
            });


            this.history.filter((data, index) => {
                // try {
                if (data.productKey == null) {
                    data.productKey = '';
                } else {
                    data.productKey = data.productKey.substring(0, 9);
                }
                // } catch (e) { }
            });



            const history = this.history.historyExport;

            try {
                this.history = history.map((h) => {
                    const device = this.history.devices.find(d => d.macAddress === h.mac);
                    if (device) {
                        return { ...h, host: device.hostname };
                    }
                    else {
                        return { ...h, host: '' };
                    }
                });
            } catch (e) { }

        },
        users() {
            this.$router.push('/admin/users');
        },
        async StatusUpdate(userId, currentStatus) {
            try {
                await API.patch(`ProductKeys/${userId}`, {
                    status: currentStatus,
                });
            } catch (error) {
                await this.$notify({
                    group: 'sitewide',
                    title: 'Error!',
                    type: 'error',
                    text: 'Unable to update status',
                });
            }
            this.getHistory(this.$route.query.id);
        },
        async updateProfile(scope) {
            try {
                const clientId = this.userId;
                await API.patch(`ProductKeys/${clientId}`, {
                    licenceKey: this.licenceKey
                });
                this.userId = null;
                this.userSettingsModal = false;
                this.$notify({
                    group: 'sitewide',
                    title: 'Success!',
                    type: 'success',
                    text: 'Updated Sucessfully',
                });
                this.getHistory(this.uuid);
            } catch (error) {
                this.userId = null;
                this.userSettingsModal = false;
                this.$notify({
                    group: 'sitewide',
                    title: 'Error!',
                    type: 'error',
                    text: 'Error while update',
                });
            }

        },
        async getDetail(userId) {
            const accountDetail = await API.get(`ProductKeys/${userId}`);
            this.licenceKey = accountDetail.licenceKey
            this.productKey = accountDetail.productKey
			this.credits =accountDetail.credits
            // console.log(accountDetail.licenceKey)
            this.userId = userId;
            this.userSettingsModal = true;
        },
    },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked+.slider {
    background-color: #d6700a;
}

input:focus+.slider {
    box-shadow: 0 0 1px #d6700a;
}

input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 20px;
}

.switch input {
    display: none;
}

.icon-width {
    width: 20px !important;
    height: 20px !important;
}

.page-item.active .page-link {
    z-index: 1;
    color: #fff;
    background-color: #6610f2 !important;
    border-color: #6610f2 !important;
}

.profile-div {
    margin-top: 50px;
    margin-left: 50px;
    width: 95% !important;
}

.Userlink {
    color: #df8031 !important;
    text-decoration: none !important;
    cursor: pointer;
}
</style>
  


// WEBPACK FOOTER //
// src/components/admin/productKey.vue